/**
 * User defined type guard to check if a value is defined or not null, use this to filter out null values
 * arrays that may contain null or undefined values.
 * @param { object | string | undefined | null } item The item to check
 * @returns { T } true if the item is defined or not null, false otherwise
 */
export const isDefined = (item) => {
    return !!item;
};
